import { useCallback, useReducer } from 'react';

export const WIZARD_AREAS = {
  NONE: '',
  INFO: 'info',
  SECTIONS: 'sections',
  QUESTION: 's-type-question',
  FILTERS: 'filters',
};

const initialState = {
  // Which sidebar area is active: '', 'info', 'sections', 's-type-question', 'filters'.
  area: WIZARD_AREAS.NONE,
  // When true the sidebar is replaced by the matching edit form.
  editing: false,
  // Selected section, same shape the section store uses: { Id, Data: { code, name } }.
  // Id === -1 means the section has no metadata entry yet (created on first save).
  selectedSection: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SELECT_AREA':
      return { ...state, area: action.area, editing: false };
    case 'SELECT_SECTION':
      return { ...state, selectedSection: action.section };
    case 'OPEN_EDITOR':
      return { ...state, area: action.area || state.area, editing: true };
    case 'CLOSE_EDITOR':
      // Leaving the question editor always lands back on the sections view.
      return {
        ...state,
        editing: false,
        area: state.area === WIZARD_AREAS.QUESTION ? WIZARD_AREAS.SECTIONS : state.area,
      };
    default:
      return state;
  }
};

// Navigation state machine for the wizard: which area is shown, whether the
// sidebar is swapped for an edit form, and which section is selected.
const useWizardNav = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const selectArea = useCallback((area) => dispatch({ type: 'SELECT_AREA', area }), []);
  const selectSection = useCallback((section) => dispatch({ type: 'SELECT_SECTION', section }), []);
  const openEditor = useCallback((area) => dispatch({ type: 'OPEN_EDITOR', area }), []);
  const closeEditor = useCallback(() => dispatch({ type: 'CLOSE_EDITOR' }), []);

  return { ...state, selectArea, selectSection, openEditor, closeEditor };
};

export default useWizardNav;
